import React, { Fragment } from 'react'
import NavBar from '../../components/NavBar'
import CMSHeader from './Header/CMSHeader'
import CMSManagemnt from './CMSManagemnt'

function UserManagement (props) {
  return (
    <Fragment>
      <NavBar {...props}/>
      <main className='main-content'>
        <section className='mangement-section common-box'>
          <CMSHeader
          {...props}
          />
          <CMSManagemnt
          {...props}
          />
        </section>
      </main>
    </Fragment>
  )
}
export default UserManagement
